"use client";

import { createContext, useContext } from "react";

type CatalogBlockContextValue = {
  path?: string;
  isCMS?: boolean;
};

const CatalogBlockContext = createContext<CatalogBlockContextValue>({});

type ProviderProps = {
  value: CatalogBlockContextValue;
  children: React.ReactNode;
};

export function CatalogBlockProvider({
  value,
  children,
}: Readonly<ProviderProps>) {
  return (
    <CatalogBlockContext.Provider value={value}>
      {children}
    </CatalogBlockContext.Provider>
  );
}

export function useCatalogBlockContext() {
  return useContext(CatalogBlockContext);
}
